import { render, staticRenderFns } from "./product_crbkcd.vue?vue&type=template&id=2b145666&scoped=true"
import script from "./product_crbkcd.vue?vue&type=script&lang=js"
export * from "./product_crbkcd.vue?vue&type=script&lang=js"
import style0 from "./product_crbkcd.vue?vue&type=style&index=0&id=2b145666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b145666",
  null
  
)

export default component.exports